'use client';
import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useDispatch, useSelector } from 'react-redux';
import { hydrateAuthFromStorage } from './redux/slices/authSlice';
import { useAppSockets } from '../hooks';
import { ThemeContextProvider, useThemeColors } from '../context/ThemeContext';
import LoadingScreen from '../components/LoadingScreen';

// Import RouteProgress dynamically to avoid SSR issues with useSearchParams
const RouteProgress = dynamic(
  () => import('../kit').then((mod) => ({ default: mod.RouteProgress })),
  { ssr: false }
);

// Inner component that can access theme colors
function AuthHydratorInner({ children }) {
  const themeColors = useThemeColors();
  const isHydrated = useSelector((state) => state.auth?.isHydrated);

  // Show loading screen while hydrating
  if (!isHydrated) {
    return <LoadingScreen message="Loading..." />;
  }

  return (
    <>
      {children}
      <RouteProgress color={themeColors.primaryColor} />
    </>
  );
}

export default function AuthHydrator({ children }) {
  const dispatch = useDispatch();
  useAppSockets();

  useEffect(() => {
    dispatch(hydrateAuthFromStorage());
  }, [dispatch]);

  return (
    <ThemeContextProvider>
      <AuthHydratorInner>{children}</AuthHydratorInner>
    </ThemeContextProvider>
  );
}
